import axios from "axios";
import axiosApi from "@axios";

const pbxManagerHeaders = {
  'X-Token': localStorage.getItem('accessToken'),
  'X-Host': window.__env.VUE_APP_BASE_URL,
};

export default {
  namespaced: true,
  state: {
    items: [],
    incomingCalls: [],
    currentCall: {},
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getIncomingCalls(state) {
      return state.incomingCalls;
    },
    getSelectedItems(state) {
      return state.items.map((server) => ({
        value: server.id,
        label: server.name,
      }));
    },
    getCurrentCall(state) {
      return state.currentCall;
    }
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setDataIncoming(state, value) {
      state.incomingCalls = value;
    },
    setCurrentCall(state, value) {
      state.currentCall = value;
    }
  },
  actions: {
    async setCurrentCall({ commit }, value) {
      commit('setCurrentCall', value);
    },
    async updateCurrentCall({ state, commit }, value) {
      commit('setCurrentCall', { ...state.currentCall, ...value });
    },
    async resetCurrentCall({ commit }) {
      commit('setCurrentCall', {});
    },
    async getAll({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_PBX_URL}/v1/calls`, {
        params,
        headers: pbxManagerHeaders
      });

      if (!data.status) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    async getIncoming({ commit }, domain) {
      const { data } = await axios.get(
        `${window.__env.VUE_APP_PBX_URL}/v1/actions/queue?domain=${domain}`, {
          headers: pbxManagerHeaders
        }
      );

      if (!data.status) {
        return [];
      }

      commit("setDataIncoming", data.data.callers ?? []);
      return data;
    },
    async updateStatusAlarm({ commit }, params) {
      const { data } = await axiosApi.post(`/v1/pbx_calls/update-status-alarm`, {
        id_session: params.call_uuid,
      });
      return data;
    },
    async takeCall({ commit, dispatch }, params) {
      const { data: callData } = await axiosApi.get(`/v1/pbx_calls/get-by-id-session/${params.call_uuid}`);
      console.log("pbx data", { callData });

      if (callData.alarm && (Array.isArray(callData.alarm) && callData.alarm.length > 0)) {
        const alarm = callData.alarm;
        await dispatch("sip/setAlarmJson", alarm, { root: true });
        setTimeout(() => {
          dispatch("updateStatusAlarm", params);
        }, 1000);
      }

      const { data } = await axios.post(
        `${window.__env.VUE_APP_PBX_URL}/v1/actions/transfer-call`,
        params,
        {
          headers: pbxManagerHeaders
        }
      );

      return data;
    },
    clear({ commit }) {
      commit("setData", []);
      commit("setDataIncoming", []);
    },
  },
};
